import React from 'react';
import { getImageUrl } from '../data/cakes';
import './CakeCard.css';

const CakeCard = ({ cake, onAddToCart }) => {
  const totalPrice = cake.base_price + (cake.custom_design_fee || 0);
  const imageUrl = getImageUrl(cake.image);

  return (
    <div className="cake-card card fade-in" onClick={() => onAddToCart(cake)} style={{ cursor: 'pointer' }}>
      <div className="cake-image-container">
        {imageUrl ? (
          <img src={imageUrl} alt={cake.title} className="cake-image" />
        ) : (
          <div className="cake-placeholder gradient-secondary">
            <span className="cake-emoji">{cake.emoji || '🎂'}</span>
          </div>
        )}
        {cake.custom_design_fee > 0 && (
          <div className="custom-badge">
            <span>✨ Custom</span>
          </div>
        )}
      </div>
      
      <div className="cake-content">
        {/*<div className="cake-category">{cake.category_name}</div>*/}
        <p className="cake-title">{cake.title}</p>
        {/*<p className="cake-description">{cake.description}</p>*/}
        
        <div className="cake-meta">
          <div className="meta-item">
            <svg className="meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"></path>
            </svg>
            <span>{cake.base_weight}kg</span>
          </div>
          <div className="meta-item">
            <svg className="meta-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
            </svg>
            <span>{cake.serves_people}</span>
          </div>
        </div>
        
        <div className="cake-footer">
          <div className="cake-price">
            <span className="price-label">Starting from</span>
            <span className="price-value">₹{totalPrice.toLocaleString()}</span>
          </div>
          <button 
            className="add-to-cart-btn ripple"
          >
            <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CakeCard;
